import { Suspense } from 'react';

import FooterMenu from '@frontend/storefront/components/layout/footer-menu';
import { useStorefrontData } from '@frontend/storefront/data';
import Image from '@frontend/storefront/Image';
import Link from '@frontend/storefront/Link';

const COMPANY_NAME = 'nopad';
const SITE_NAME = 'nopad';

const legalLinks = [
  { title: 'Instagram', path: 'https://www.instagram.com/nopad_movement/' },
  { title: 'Terms', path: '/terms' },
  { title: 'Privacy', path: '/privacy' },
];

export default function Footer() {
  // Fixed at build time; the site rebuilds at least nightly.
  const currentYear = new Date().getFullYear();
  const skeleton = 'w-full h-6 animate-pulse rounded-sm bg-np-card';
  const menu = useStorefrontData().menus['footer'];
  const copyrightName = COMPANY_NAME || SITE_NAME || '';

  return (
    <footer className="mt-12 text-sm text-np-ink/70">
      <div className="mx-auto flex w-full max-w-[1312px] flex-col gap-6 border-t border-np-ink/15 px-4 py-12 md:flex-row md:gap-12">
        <div>
          <Link href="/" className="block md:pt-2">
            <Image
              src="/home/logo.svg"
              alt={SITE_NAME || 'nopad'}
              width={80}
              height={24}
            />
          </Link>
        </div>
        <Suspense
          fallback={
            <div className="flex h-[96px] w-[200px] flex-col gap-2">
              <div className={skeleton} />
              <div className={skeleton} />
              <div className={skeleton} />
            </div>
          }
        >
          <FooterMenu menu={menu} />
        </Suspense>
      </div>
      <div className="border-t border-np-ink/15 py-6">
        <div className="mx-auto flex w-full max-w-[1312px] flex-col items-center gap-3 px-4 md:flex-row">
          <p>
            &copy; {currentYear} {copyrightName}. All rights reserved.
          </p>
          <ul className="flex gap-4 md:ml-auto">
            {legalLinks.map((link) => (
              <li key={link.path}>
                <Link
                  href={link.path}
                  className="underline-offset-4 hover:text-np-ink hover:underline"
                >
                  {link.title}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </footer>
  );
}
